import { defineComponent, computed } from "vue";
import { isCNSuffix } from "@com/utils/url";
export default defineComponent({
    name: "TotalFooter",
    props: {
        price: {
            type: Number,
            required: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var currency = computed(function() {
            return isCNSuffix() ? "CNY" : "USD";
        });
        return {
            currency: currency
        };
    }
});
